"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpisodeTopicTargetsResponseToJSON = exports.EpisodeTopicTargetsResponseFromJSONTyped = exports.EpisodeTopicTargetsResponseFromJSON = exports.instanceOfEpisodeTopicTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the EpisodeTopicTargetsResponse interface.
 */
function instanceOfEpisodeTopicTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfEpisodeTopicTargetsResponse = instanceOfEpisodeTopicTargetsResponse;
function EpisodeTopicTargetsResponseFromJSON(json) {
    return EpisodeTopicTargetsResponseFromJSONTyped(json, false);
}
exports.EpisodeTopicTargetsResponseFromJSON = EpisodeTopicTargetsResponseFromJSON;
function EpisodeTopicTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'episodeTopics': !(0, runtime_1.exists)(json, 'episode_topics') ? undefined : (json['episode_topics'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.EpisodeTopicTargetsResponseFromJSONTyped = EpisodeTopicTargetsResponseFromJSONTyped;
function EpisodeTopicTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'episode_topics': value.episodeTopics === undefined ? undefined : (value.episodeTopics.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.EpisodeTopicTargetsResponseToJSON = EpisodeTopicTargetsResponseToJSON;
